import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import NoticiaTopo from '../section-pages/noticia-topo'; 
import NoticiaTexto from '../section-pages/noticia-texto';
import NoticiaGaleria from '../section-pages/noticia-galeria';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import ApiNoticias from '../services/noticiaService';

const image1 = '../../img/background/bg-grid.webp';

const GlobalStyles = createGlobalStyle`
  /* Adicione seus estilos globais aqui */
`;

export default function Noticia() {
  const { slug } = useParams();
  const [noticia, setNoticia] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        const response = await ApiNoticias.obterPorUrl(slug);
        setNoticia(response.data[0]);
      } catch (error) {
        console.error('Erro ao buscar notícias:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNoticia();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
  }, []);

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      <GlobalStyles />

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        <section>
            {noticia ? (
                <NoticiaTopo
                    foto={noticia.foto}
                    titulo={noticia.titulo}
                    previa={noticia.previa}
                    dataPublicacao={noticia.dataPublicacao}
                />
            ) : (
                <p>Carregando notícia...</p>
            )}
        </section>

        <section className="noticia-section">
            {noticia? (
                <NoticiaTexto descricao={noticia.descricao}/>
            ) : (
                <p>Carregando notícia...</p>
            )}
        </section>

        {/* <section className="noticia-section">
            {noticia? (
                <NoticiaGaleria />
            ) : (
                <p>Carregando notícia...</p>
            )}
        </section> */}

        {/* Footer */}
        <Footer />
      </div>

      <ScrollToTopBtn />
    </>
  );
}
